import { getMapInstance } from '@bpd-library/components';
import { BoundingBox, Coordinates, MapDataItem } from '@bpd-library/types';
import {
    calculateBoundingBox,
    calculateMapDataBoundingBox,
    expandBoundingBox,
    ExtendedAreaModels,
    getApiObjectCenter,
    getApiObjectCoordinates,
} from '@bpd-library/utilities';
import { isGermany } from '@utilities/is-germany';

function getBoundingBox(
    data: ExtendedAreaModels,
    mapData?: MapDataItem[],
): BoundingBox | undefined {
    let boundingBox: BoundingBox | undefined;

    if (isGermany()) {
        // If the environment is germany, base it on area and project polygons
        boundingBox = getGermanyBoundingBox(data);
    } else {
        // If the environment is not germany, base it on the mapdata
        if (mapData?.length) {
            boundingBox = calculateMapDataBoundingBox(mapData);
            boundingBox = expandBoundingBox(boundingBox, 0.075);
        }
    }

    if (!boundingBox) {
        // If there's no mapdata, use the center of the areaProject
        const center = getApiObjectCenter(data.areaProject);

        if (center) {
            boundingBox = calculateBoundingBox(center);
            boundingBox = expandBoundingBox(boundingBox, 0.4);
        }
    }

    return boundingBox;
}

function setPropertiesMapBounds(data: ExtendedAreaModels, mapData: MapDataItem[]) {
    const mapInstance = getMapInstance();

    // Set map boundingbox delayed, for visual effect
    setTimeout(() => {
        const boundingBox = getBoundingBox(data, mapData);

        if (boundingBox) mapInstance?.fitBounds(boundingBox, { duration: 1200 });
    }, 600);
}

function getGermanyBoundingBox(data: ExtendedAreaModels): BoundingBox | undefined {
    /*
        Germany doesn't have any construction number / property type polygons yet.
        Instead, use the areaProject and projectPhases to calculate the boundingbox.
    */
    const areaProjectCoordinates = getApiObjectCoordinates(data.areaProject) || [];
    const projectPhaseCoordinates = data.projectPhases.reduce<Coordinates>(
        (projectPhaseCoordinates, projectPhase) => {
            const coordinates = getApiObjectCoordinates(projectPhase);

            return coordinates
                ? [...projectPhaseCoordinates, ...coordinates]
                : projectPhaseCoordinates;
        },
        [],
    );

    let boundingBox: BoundingBox | undefined;

    if (areaProjectCoordinates.length || projectPhaseCoordinates.length) {
        boundingBox = calculateBoundingBox([...areaProjectCoordinates, ...projectPhaseCoordinates]);
    }

    return boundingBox;
}

export { getBoundingBox, setPropertiesMapBounds };
